import { render } from "./Glass.vue?vue&type=template&id=6bbc7831"
import script from "./Glass.vue?vue&type=script&lang=js"
export * from "./Glass.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__